import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, EmbeddedSignupSchema, EmbeddedSignupResponseDataSchema } from "schema"
import { z } from "zod"
import { whatsappIntegrationQuery } from "../../lib/whatsapp/whatsappIntegrationQuery"
import { settingsWhatsappNumbersQuery } from "../../lib/whatsapp/settingsWhatsappNumbersQuery"

type Response = DataResponse<z.infer<typeof EmbeddedSignupResponseDataSchema>>

export function useEmbeddedSignupMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.input<typeof EmbeddedSignupSchema>) => {
      const response = await axios.post<Response>(`/integrations/whatsapp/embedded`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: whatsappIntegrationQuery().queryKey })
      queryClient.invalidateQueries({ queryKey: settingsWhatsappNumbersQuery().queryKey })
    },
  })
}
